import { isValidatedMasterRow } from './crash-list-merge-provenance.util';

export { isValidatedMasterRow };

export function isMergeSourceChildRow(row) {
  return Boolean(row?.isMergeSourceChild);
}

export function masterHasMergeSources(row) {
  if (!row || !isValidatedMasterRow(row)) return false;
  const sourceCount = Number(row.merge_source_count ?? 0);
  if (Number.isFinite(sourceCount) && sourceCount > 0) return true;
  if (row.merge_source_count != null) return false;
  const basics = row.merged_from_basics;
  return Array.isArray(basics) && basics.length > 0;
}

export function dedupeRowsByCrashId(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return [];

  const seen = new Set();
  const unique = [];
  rows.forEach((row) => {
    const crashId = String(row?.['Crash id'] ?? '').trim();
    if (!crashId || seen.has(crashId)) return;
    seen.add(crashId);
    unique.push(row);
  });
  return unique;
}

export function buildValidatedSourceChildRows(masterCrashId, sourceRows) {
  const masterId = String(masterCrashId ?? '').trim();
  return dedupeRowsByCrashId(sourceRows).map((row) => {
    const crashId = String(row['Crash id'] ?? '').trim();
    return {
      ...row,
      gridRowId: `validated-source-${masterId}-${crashId}`,
      isMergeSourceChild: true,
      hierarchyLevel: 1,
    };
  });
}

function groupMasterRowsByCrashId(masterRows) {
  const crashIdOrder = [];
  const seenCrashIds = new Set();
  const rowsByCrashId = new Map();

  masterRows.forEach((row) => {
    const crashId = String(row?.['Crash id'] ?? '').trim();
    if (!crashId) return;

    if (!rowsByCrashId.has(crashId)) {
      rowsByCrashId.set(crashId, []);
      seenCrashIds.add(crashId);
      crashIdOrder.push(crashId);
    }
    rowsByCrashId.get(crashId).push(row);
  });

  return { crashIdOrder, rowsByCrashId };
}

export function buildValidatedDisplayRows({ masterRows, expandedMasterIds, sourcesByMaster }) {
  if (!Array.isArray(masterRows) || masterRows.length === 0) return [];

  const ordered = [];
  const insertedChildIds = new Set();
  const { crashIdOrder, rowsByCrashId } = groupMasterRowsByCrashId(masterRows);

  crashIdOrder.forEach((masterCrashId) => {
    const joinRows = rowsByCrashId.get(masterCrashId) ?? [];
    joinRows.forEach((master) => {
      ordered.push({ ...master, isMergeSourceChild: false, hierarchyLevel: 0 });
    });

    if (!expandedMasterIds.has(masterCrashId)) return;

    const children = sourcesByMaster.get(masterCrashId) ?? [];
    children.forEach((child) => {
      const childCrashId = String(child['Crash id'] ?? '').trim();
      if (!childCrashId || insertedChildIds.has(childCrashId)) return;
      insertedChildIds.add(childCrashId);
      ordered.push(
        child.isMergeSourceChild
          ? child
          : { ...child, isMergeSourceChild: true, hierarchyLevel: 1 },
      );
    });
  });

  return ordered;
}

export function filterExportRows(rows, view) {
  if (view !== 'validated') return rows;
  return rows.filter((row) => isValidatedMasterRow(row));
}
